import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import { pollForPathwayName } from '../utils/pollForPathwayName';

export const updatePathwayName = (id: string, name: string, orgId: string, initiatingUserId: string) => {
  cacheService.remove(`/v1/workflows/${id}`);
  const cmd = { id, name, owner: orgId, initiatingUserId };
  return submitCommand(id, cmd, 'UpdateWorkflowName', 'WorkflowNameChanged', 'WorkflowNameDuplicateError').then(() =>
    pollForPathwayName(id, name)
  );
};
